import { HttpErrorResponse } from '@angular/common/http';
import { debounce } from 'lodash';

const messages: any = {};

export function toast(summary: string, details: string, toastClass: string) {
	const key = summary + details;

	let showToast = messages[key];

	if (!showToast) {
		showToast = messages[key] = debounce(() => {
			$('body')
				.toast({
					displayTime: 'auto',
					class: toastClass,
					position: 'bottom right',
					newestOnTop: true,
					title: summary,
					message: details
				});

			setTimeout(() => {
				delete messages[key];
			}, 200);
		}, 5000, {
			leading: true,
			trailing: false
		});
	}

	showToast();
}

export function toastHttpError(httpErr: HttpErrorResponse) {
	toastGenericError(httpErr.error instanceof ErrorEvent, httpErr.status);
}

export function toastRequestDenied(message: string) {
	toast('Request was denied.', message, 'orange');
}

export function toastGenericError(isClientError = true, status: number | null = null) {
	const summary = `Error${status ? ` (status: ${status})` : ''}`;
	let details = `There is a problem with the ${isClientError ? 'client' : 'server'}, we are sorry for the inconvenience.`;

	toast(summary, details, 'red');
}

export function toastRequestUnauthorized(status: number) {
	const summary = `Error (${status})`;
	const details = `Your session has expired or you don't have the necessary permissions.`;

	toast(summary, details, 'orange');
}
